import { NgModule } from '@angular/core';
import { AmdInputContainerComponent } from '../input-container/input-container.component';
export class AmdInputContainerModule {
}
AmdInputContainerModule.decorators = [
    { type: NgModule, args: [{
                declarations: [AmdInputContainerComponent],
                exports: [AmdInputContainerComponent]
            },] },
];
/**
 * @nocollapse
 */
AmdInputContainerModule.ctorParameters = () => [];
function AmdInputContainerModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdInputContainerModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdInputContainerModule.ctorParameters;
}
//# sourceMappingURL=input-container.module.js.map
//# sourceMappingURL=input-container.module.js.map
